import { VERSIONS } from "@/config/version.js";

export default {
  getVersion() {
    const environment = this.getEnvironment();
    return VERSIONS[environment];
  },
  getEnvironment() {
    return process.env.NODE_ENV
  },
  isDevelop(){
    return process.env.NODE_ENV === "develop"
  },
  isStaging(){
    return process.env.NODE_ENV === "staging"
  },
  isProduction() {
    return process.env.NODE_ENV === "production"
  }
};
